import { api } from '../main-api/apiClient';

// Tenant Admin Question Management API services
export const tenantAdminQuestionAPI = {
  // Get tenant questions (global + tenant-specific)
  getQuestions: (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    return api.get(`/tenant-admin/questions?${queryString}`);
  },
  
  // Create a new tenant-specific question
  createQuestion: (questionData) => {
    const formData = new FormData();
    Object.keys(questionData).forEach(key => {
      if (questionData[key] !== null && questionData[key] !== undefined && questionData[key] !== '') {
        formData.append(key, questionData[key]);
      }
    });
    return api.post('/tenant-admin/questions', formData);
  },
  
  // Update a tenant question
  updateQuestion: (questionId, questionData) => {
    const formData = new FormData();
    Object.keys(questionData).forEach(key => {
      if (questionData[key] !== null && questionData[key] !== undefined && questionData[key] !== '') {
        formData.append(key, questionData[key]);
      }
    });
    return api.put(`/tenant-admin/questions/${questionId}`, formData);
  },
  
  // Delete a tenant question
  deleteQuestion: (questionId) => {
    return api.delete(`/tenant-admin/questions/${questionId}`);
  },
  
  // Reorder tenant questions
  reorderQuestions: (questionOrders) => {
    return api.post('/tenant-admin/questions/reorder', questionOrders);
  },
  
  // Get tenant question analytics
  getQuestionAnalytics: () => {
    return api.get('/tenant-admin/questions/analytics');
  },
  
  // Preview patient questions
  previewPatientQuestions: () => {
    return api.get('/tenant-admin/questions/preview');
  }
};

export default tenantAdminQuestionAPI;